import styled, { css } from "styled-components";
import {
    CardHeadingLabel,
    ExplainParagraphLabel
} from "src/components";
import { Hr } from "src/components/SubscriptionElements";

export const PageIntro = styled.div`
    max-width: 1138px;
    width: 100%;
    margin-top: 32px;
`;

export const StoragePageHeading = styled(CardHeadingLabel)`
    margin-top: 0;
`;

export const StorageIntroText = styled(ExplainParagraphLabel)`
    flex-shrink: 0;
    font: normal normal normal 14px/16px Roboto;
    max-width: 643px;
`;

export const StorageDivider = styled(Hr)`
    margin-left: -1.55em;
    margin-right: -2em;
    width: calc(100% + 10em);
`;

export const StorageShell = styled.div`
    box-shadow: 0px 5px 5px #00000026;
    border: 1px solid #8291B2;
    border-radius: 12px;
    max-width: 1085px;
    width: 100%;
    overflow: hidden;
`;

export const StorageHeader = styled.div`
    background-color: #121EB1;
    display: flex;
    align-items: center;
    gap: 10px;
    min-height: 50px;
    padding: 0 20px;
`;

export const StorageHeaderIcon = styled.img`
    height: 20px;
    width: 20px;
`;

export const StorageTitle = styled.div`
    font: normal normal bold 20px/24px Roboto;
    color: #FFFFFF;
`;

export const StorageBody = styled.div`
    display: grid;
    grid-template-columns: minmax(290px, 1.7fr) minmax(210px, 1fr) minmax(210px, .8fr);
    gap: 14px;
    padding: 15px 20px 24px;

    @media (max-width: 1120px) {
        grid-template-columns: 1fr;
    }
`;

export const StorageLoadingWrap = styled.div`
    min-height: 160px;
    position: relative;
`;

export const UsageCard = styled.div`
    background: #FFFFFF;
    border: 1px solid #BBC4D9;
    border-radius: 8px;
    box-shadow: 0px 5px 5px #0000001A;
    box-sizing: border-box;
    min-height: 140px;
    padding: 16px 18px 14px;
`;

export const UsageHeader = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
`;

export const UsageAmount = styled.div`
    color: #121EB1;
    font: normal normal bold 16px/20px Roboto;
`;

export const UsageText = styled.div`
    color: #11141A;
    font: normal normal 500 14px/18px Roboto;
`;

export const LimitText = styled.div`
    color: #121EB1;
    font: normal normal bold 30px/34px Roboto;
    white-space: nowrap;
`;

export const SidebarLimitText = styled(LimitText)`
    font-size: 22px;
    line-height: 26px;
`;

export const ProgressTrack = styled.div`
    background: #EEF3FA;
    border: 1px solid #BBC4D9;
    border-radius: 999px;
    box-shadow: inset 0px 2px 4px #0000001A;
    height: 18px;
    margin: 15px 0 12px;
    overflow: hidden;
`;

export const SidebarProgressTrack = styled(ProgressTrack)`
    height: 15px;
`;

export const ProgressFill = styled.div`
    background: linear-gradient(90deg, #6B2ACB 0%, #58C8FF 100%);
    height: 100%;
    width: ${p => {
        const percentage = Number(p.percentage) || 0;
        if (percentage <= 0) return 0;
        return Math.min(Math.max(percentage, 1), 100);
    }}%;
`;

export const PrimaryButton = styled.button`
    width: ${p => p.width || "101px"};
    height: 39px;
    background: #006CFF;
    border: 0;
    border-radius: 6px;
    box-shadow: 0px 4px 6px #00000026;
    color: #FFFFFF;
    cursor: pointer;
    font: normal normal bold 14px/17px Roboto;
    min-height: 36px;
    padding: 0 22px;

    &:disabled {
        cursor: not-allowed;
        opacity: .6;
    }
`;

export const FullWidthPrimaryButton = styled(PrimaryButton)`
    width: 100%;
`;

export const UpgradeActionButton = styled(PrimaryButton)`
    margin-top: auto;
`;

export const BlackButton = styled(PrimaryButton)`
    background: #000000;
`;

export const CategoryGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px 14px;
`;

export const CategoryCard = styled.div`
    background: #FFFFFF;
    border: 1px solid #BBC4D9;
    border-radius: 8px;
    box-shadow: 0px 5px 5px #0000001A;
    box-sizing: border-box;
    min-height: 65px;
    padding: 12px 14px;
    width: auto;
`;

export const CategoryTop = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 10px;
`;

export const CategoryName = styled.div`
    color: #121EB1;
    font: normal normal bold 15px/18px Roboto;
`;

export const CategoryPercent = styled.div`
    color: #121EB1;
    font: normal normal bold 14px/18px Roboto;
`;

export const CategoryCount = styled.div`
    color: #11141A;
    font: normal normal 500 14px/18px Roboto;
    margin-top: 3px;
`;

export const ManagementCard = styled(UsageCard)`
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const ManagementTitle = styled.div`
    color: #11141A;
    font: normal normal bold 16px/20px Roboto;
    margin-bottom: 7px;
`;

export const ManagementCopy = styled.div`
    color: #11141A;
    font: normal normal 500 14px/17px Roboto;
    margin-bottom: 16px;
    max-width: 240px;
`;

export const ModalPanel = styled.div`
    background: #FFFFFF;
    border-radius: 8px;
    box-shadow: 0px 10px 30px #00000029;
    width: min(880px, calc(100vw - 32px));
    max-height: 92vh;
    overflow: auto;
`;

export const UpgradeContent = styled.div`
    padding: 42px 34px 38px;
    text-align: center;
`;

export const UpgradeTitle = styled.h2`
    color: #11141A;
    font: normal normal bold 34px/40px Roboto;
    margin: 0 0 8px;
`;

export const UpgradeDescription = styled.p`
    color: #11141A;
    font: normal normal normal 14px/16px Roboto;
    margin: 0 auto 42px;
    max-width: 680px;
`;

export const UpgradeGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 22px;
    margin-bottom: 44px;

    @media (max-width: 880px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @media (max-width: 560px) {
        grid-template-columns: 1fr;
    }
`;

export const UpgradeCard = styled.div`
    border: 1.5px solid ${({ $active }) => ($active ? "#121EB1" : "#BBC4D9")};
    border-radius: 8px;
    box-shadow: 0px 5px 5px #0000001A;
    min-height: 245px;
    padding: 28px 18px 18px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const UpgradeAmount = styled.div`
    color: #121EB1;
    font: normal normal bold 28px/34px Roboto;
`;

export const UpgradeLabel = styled.div`
    color: #121EB1;
    font: normal normal bold 14px/18px Roboto;
    margin: 8px 0 6px;
`;

export const UpgradePrice = styled.div`
    color: #11141A;
    font: normal normal bold 14px/18px Roboto;
`;

export const UpgradeCardCopy = styled.div`
    color: #11141A;
    font: normal normal 500 14px/16px Roboto;
    margin: 10px 0 18px;
`;

export const ModalCancelButton = styled.button`
    background: #FFFFFF;
    border: 1px solid #11141A;
    border-radius: 5px;
    box-shadow: 0px 4px 6px #00000026;
    color: #11141A;
    cursor: pointer;
    font: normal normal bold 13px/16px Roboto;
    height: 34px;
    min-width: 138px;
`;

export const ManagePanel = styled(ModalPanel)`
    width: min(1260px, calc(100vw - 28px));
    height: min(900px, 94vh);
    background: #DDDDDD;
    border-radius: 15px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`;

export const ManageHeader = styled.div`
    align-items: flex-start;
    border-bottom: 1px solid #C9D2E3;
    display: flex;
    gap: 24px;
    justify-content: space-between;
    padding: 18px 18px 16px;
`;

export const ManageTitle = styled.h2`
    color: #11141A;
    font: normal normal bold 28px/34px Roboto;
    margin: 0 0 7px;
`;

export const ManageIntro = styled.p`
    color: #11141A;
    font: normal normal 500 13px/17px Roboto;
    margin: 0;
    max-width: 800px;
`;

export const CloseTextButton = styled(ModalCancelButton)`
    flex: 0 0 auto;
    min-width: 124px;
`;

export const ManageLayout = styled.div`
   display: grid;
    grid-template-columns: 300px 1fr;
    flex: 1;
    min-height: 0;
    overflow: hidden;

    @media (max-width: 900px) {
        grid-template-columns: 1fr;
    }
`;

export const ManageSidebar = styled.div`
    background: #DDDDDD;
    border-right: 1px solid #C9D2E3;
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 18px 10px;
`;

export const SidebarCategoryGrid = styled(CategoryGrid)`
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
`;

export const SidebarUsage = styled(UsageCard)`
    min-height: 105px;
    padding: 12px;
`;

export const SidebarButtonWrap = styled.div`
    margin-top: auto;
`;

export const ManageMain = styled.div`
    background: #FFFFFF;
    display: flex;
    flex-direction: column;
    min-height: 0;
`;

export const Toolbar = styled.div`
    align-items: center;
    border-bottom: 1px solid #C9D2E3;
    display: flex;
    gap: 16px;
    padding: 16px 24px;
`;

export const SearchWrap = styled.div`
    flex: 1;
    position: relative;

    &::before {
        content: "";
        border: 2px solid #8291B2;
        border-radius: 50%;
        height: 10px;
        left: 16px;
        position: absolute;
        top: 50%;
        transform: translateY(-55%);
        width: 10px;
    }

    &::after {
        content: "";
        background: #8291B2;
        height: 7px;
        left: 27px;
        position: absolute;
        top: 50%;
        transform: rotate(-45deg);
        width: 2px;
    }
`;

export const SearchInput = styled.input`
    border: 1px solid #BBC4D9;
    border-radius: 6px;
    box-shadow: 0px 2px 5px #0000001A;
    box-sizing: border-box;
    color: #11141A;
    font: normal normal 500 14px/18px Roboto;
    height: 38px;
    padding: 0 16px 0 42px;
    width: 100%;

    &::placeholder {
        color: #8291B2;
    }
`;

export const ViewToggle = styled.button`
    background: transparent;
    border: 0;
    cursor: pointer;
    height: 28px;
    padding: 0;
    position: relative;
    width: 32px;
`;

export const FilesSection = styled.div`
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 18px 24px 28px;
`;

export const SectionTitle = styled.div`
    color: var(--calendar-text, #171A22);
    font-family: Manrope, Helvetica, sans-serif;
    font-size: 0.95rem;
    font-weight: 800;
    line-height: 1.3;
    margin-bottom: 1rem;
`;

export const FileGrid = styled.div`
    display: ${p => p.viewMode === "list" ? "block" : "grid"};
    grid-template-columns: repeat(auto-fill, minmax(9.5rem, 1fr));
    gap: 0.85rem;
`;

export const FileTile = styled.div`
    cursor: pointer;
    position: relative;
    min-height: 13rem;
    display: flex;
    flex-direction: column;
    text-align: center;
    padding: 0.65rem;
    background: var(--calendar-surface-secondary, #F3F5FB);
    border: 1px solid var(--calendar-border, #D8DEEC);
    border-radius: 10px;
    box-sizing: border-box;
    transition: background 0.16s ease, border-color 0.16s ease, box-shadow 0.16s ease, transform 0.16s ease;
    z-index: ${p => p.menuOpen ? 20 : 1};

    &:hover {
        background: var(--calendar-surface, #FFFFFF);
        border-color: var(--calendar-border-strong, #C9D2E7);
        box-shadow: 0 10px 20px rgba(29, 42, 89, 0.08);
        transform: none;
    }

    ${p => p.viewMode === "list" && css`
        align-items: center;
        display: grid;
        grid-template-columns: 3rem minmax(0, 1fr) auto;
        gap: 0.7rem;
        min-height: 4rem;
        margin-bottom: 0.45rem;
        padding: 0.5rem 0.6rem;
        text-align: left;
    `}

    @media (prefers-reduced-motion: reduce) {
        transition: none;

        &:hover {
            transform: none;
        }
    }
`;

export const FileThumb = styled.div`
    align-items: center;
    aspect-ratio: 4 / 3;
    background: var(--calendar-surface-tertiary, #EEF2F9);
    border: 1px solid var(--calendar-border, #D8DEEC);
    border-radius: 7px;
    display: flex;
    justify-content: center;
    overflow: hidden;
    position: relative;

    ${p => p.viewMode === "list" && css`
        aspect-ratio: 1;
        height: 3rem;
        width: 3rem;
    `}

    img,
    video {
        height: 100%;
        object-fit: cover;
        width: 100%;
    }
`;

export const FileName = styled.div`
    color: var(--calendar-text, #171A22);
    font-family: Manrope, Helvetica, sans-serif;
    font-size: 0.7125rem;
    font-weight: 700;
    line-height: 1.35;
    text-align: left;
    margin-top: 0.65rem;
    overflow-wrap: anywhere;

    ${p => p.viewMode === "list" && css`
        font-size: 0.8125rem;
        margin-top: 0;
    `}
`;

export const FileInfo = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 0;
    min-width: 0;
`;

export const FileSource = styled.div`
    color: var(--calendar-text-muted, #6A7387);
    font-family: Manrope, Helvetica, sans-serif;
    font-size: 0.7rem;
    font-weight: 500;
    line-height: 1.3;
    margin-top: auto;
    text-align: left;
`;

export const FileSize = styled.div`
    color: var(--calendar-text-muted, #6A7387);
    display: ${p => p.viewMode === "list" ? "block" : "none"};
    font-family: Manrope, Helvetica, sans-serif;
    font-size: 0.75rem;
    font-weight: 500;
    line-height: 1.35;
    margin-top: 0.2rem;
`;

export const FileMenuButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;

    width: 2rem;
    height: 2rem;
    padding: 0;

    background: var(--calendar-surface, #FFFFFF);
    border: 1px solid var(--calendar-border, #D8DEEC);
    border-radius: 7px;
    color: var(--calendar-text, #171A22);
    cursor: pointer;

    font-family: Manrope, Helvetica, sans-serif;
    font-size: 1.125rem;
    font-weight: 700;
    line-height: 1;

    position: absolute;
    right: 0.8rem;
    top: 0.8rem;

    ${p => p.viewMode === "list" && css`
        height: 1.875rem;
        position: static;
        width: 1.875rem;
    `}

    &:hover {
        background: var(--calendar-surface-secondary, #F3F5FB);
        border-color: var(--calendar-border-strong, #C9D2E7);
    }
`;

export const FileMenu = styled.div`
    background: var(--calendar-surface, #FFFFFF);
    border: 1px solid var(--calendar-border-strong, #C9D2E7);
    border-radius: 8px;
    box-shadow: 0 14px 28px rgba(29, 42, 89, 0.16);
    min-width: 8.25rem;
    padding: 0.3rem;
    position: absolute;
    right: 0.8rem;
    top: 3.15rem;
    z-index: 2;

    ${p => p.viewMode === "list" && css`
        right: 0.6rem;
        top: 3rem;
    `}
`;

export const FileMenuItem = styled.button`
    background: transparent;
    border: 0;
    border-radius: 6px;
    color: ${p => p.danger ? "#D64545" : "var(--calendar-text, #171A22)"};
    cursor: pointer;
    display: block;
    font-family: Manrope, Helvetica, sans-serif;
    font-size: 0.8125rem;
    font-weight: 600;
    line-height: 1.35;
    padding: 0.55rem 0.65rem;
    text-align: left;
    width: 100%;

    &:hover {
        background: ${p => p.danger ? "#FFF5F5" : "var(--calendar-surface-secondary, #F3F5FB)"};
    }
`;

export const EmptyState = styled.div`
    border: 1px dashed var(--calendar-border-strong, #C9D2E7);
    border-radius: 10px;
    color: var(--calendar-text-muted, #6A7387);
    font-family: Manrope, Helvetica, sans-serif;
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 1.5;
    padding: 2rem;
    text-align: center;
`;

export const DocumentIcon = styled.div`
    border: 4px solid #8291B2;
    border-radius: 4px;
    height: 58px;
    position: relative;
    width: 44px;

    &::before,
    &::after {
        background: #8291B2;
        content: "";
        height: 4px;
        left: 9px;
        position: absolute;
        width: 24px;
    }

    &::before {
        top: 22px;
    }

    &::after {
        top: 34px;
    }
`;

export const AudioIcon = styled(DocumentIcon)`
    &::before {
        border: 4px solid #8291B2;
        border-radius: 50%;
        background: transparent;
        height: 30px;
        left: 8px;
        top: 14px;
        width: 30px;
    }

    &::after {
        border-bottom: 8px solid transparent;
        border-left: 12px solid #8291B2;
        border-top: 8px solid transparent;
        background: transparent;
        height: 0;
        left: 23px;
        top: 25px;
        width: 0;
    }
`;

export const PlayBadge = styled.div`
    border: 4px solid #FFFFFF;
    border-radius: 50%;
    height: 48px;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 48px;

    &::after {
        border-bottom: 12px solid transparent;
        border-left: 18px solid #FFFFFF;
        border-top: 12px solid transparent;
        content: "";
        left: 17px;
        position: absolute;
        top: 10px;
    }
`;

export const PreviewPanel = styled(ModalPanel)`
    border-radius: 8px;
    max-height: 94vh;
    overflow: hidden;
    width: min(1220px, calc(100vw - 32px));
`;

export const PreviewHeader = styled.div`
    align-items: center;
    border-bottom: 1px solid #C9D2E3;
    display: flex;
    justify-content: space-between;
    min-height: 76px;
    padding: 0 18px;
`;

export const PreviewTitle = styled.div`
    color: #11141A;
    font: normal normal 500 15px/18px Roboto;
    overflow-wrap: anywhere;
`;


export const PreviewBody = styled.div`
    align-items: center;
    background: #D9D9D9;
    display: flex;
    height: min(720px, calc(94vh - 76px));
    justify-content: center;
    padding: 52px 40px;

    img,
    video {
        max-height: 100%;
        max-width: 100%;
        object-fit: contain;
    }
`;

export const PreviewFrame = styled.iframe`
    background: #FFFFFF;
    border: 0;
    height: 100%;
    width: 100%;
`;

export const PreviewFallback = styled.div`
    align-items: center;
    color: #4D5A73;
    display: flex;
    flex-direction: column;
    font-family: Manrope, Helvetica, sans-serif;
    font-size: 0.875rem;
    font-weight: 600;
    gap: 1rem;
    line-height: 1.4;
    text-align: center;
`;
